// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"0405e638","246":"fc18be03","647":"20f801fa"}[chunkId] + ".chunk.css";
};